import { SubmitContext } from 'contexts/SubmitContext';
import { useContext } from 'react';

export const useSubmitting = () => useContext(SubmitContext)